import { Reveal } from "@/components/motion";
import { useLang } from "@/context/LangContext";

const Num = ({ v, l, className = "" }) => (
  <div className={className}>
    <p className="font-display text-5xl sm:text-6xl font-black tracking-tight">{v}</p>
    <p className="mt-2 text-sm leading-snug opacity-90">{l}</p>
  </div>
);

export const Bento = () => {
  const { t } = useLang();
  return (
  <section data-testid="home-bento" className="bg-[var(--paper)] py-24 sm:py-32">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <Reveal>
        <p className="eyebrow">{t("Minaqu dalam angka", "Minaqu in numbers")}</p>
        <h2 className="mt-4 max-w-3xl font-display text-4xl sm:text-5xl font-black tracking-tight leading-[0.95]">{t("Dari kebun petani Indonesia ke lebih dari 20 negara.", "From Indonesian farmers' gardens to more than 20 countries.")}</h2>
      </Reveal>
      <div className="mt-14 grid auto-rows-[220px] grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Reveal className="relative overflow-hidden rounded-[2rem] sm:col-span-2 sm:row-span-2 text-white">
          <img src="/assets/img/farmers.jpg" alt={t("Kolaborasi dengan petani", "Collaboration with farmers")} className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[var(--leaf-deep)] via-leafdeep/30 to-transparent" />
          <Num v="1.000+" l={t("Petani Indonesia berkolaborasi lewat program KUR, Petani Mandiri & Petani Milenial.", "Indonesian farmers collaborating through the KUR, Independent Farmer & Millennial Farmer programmes.")} className="absolute bottom-7 left-7 right-7" />
        </Reveal>
        <Reveal delay={0.08} className="rounded-[2rem] bg-[var(--leaf)] p-7 text-white flex flex-col justify-end">
          <Num v="20+" l={t("Negara klien & existing market — dari Jerman, Belanda, hingga Korea Selatan.", "Client & existing-market countries — from Germany and the Netherlands to South Korea.")} />
        </Reveal>
        <Reveal delay={0.16} className="rounded-[2rem] bg-[var(--mint)] p-7 text-[var(--leaf-deep)] flex flex-col justify-end">
          <Num v={t("7 Juta", "7 Million")} l={t("Plantlet per tahun untuk tanaman kultur jaringan bersama mitra strategis.", "Tissue culture plantlets per year with our strategic partner.")} />
        </Reveal>
        <Reveal delay={0.1} className="relative overflow-hidden rounded-[2rem] bg-[var(--ink)] p-7 text-white sm:col-span-2 flex items-end">
          <img src="/assets/img/tc-lab-2.jpg" alt={t("Laboratorium kultur jaringan", "Tissue culture laboratory")} className="absolute inset-y-0 right-0 h-full w-1/2 object-cover opacity-80 [clip-path:polygon(18%_0,100%_0,100%_100%,0_100%)]" />
          <Num v="34" l={t("Eco-region Indonesia — pusat megabiodiversitas dunia, sumber tanaman eksotis kami.", "Indonesian eco-regions — a global megabiodiversity hotspot and the source of our exotic plants.")} className="relative max-w-[50%]" />
        </Reveal>
      </div>
    </div>
  </section>
  );
};
